export default "__VITE_ASSET__pcvMbmCF__"